module.exports = __webpack_public_path__ + "img/icon_ct_arr_on.824d16d8.svg";